<template>
    <div class="color-table">
        <el-table :data="modelValue">
            <el-table-column prop="color1" label="基础" width="55">
                <template #default="scope">
                    <div :style="`background-color: ${scope.row.color1}`" class="colorPan"></div>
                </template>
            </el-table-column>
            <el-table-column prop="color2" label="渐变" width="55">
                <template #default="scope">
                    <div :style="`background-color: ${scope.row.color2}`" class="colorPan"></div>
                </template>
            </el-table-column>
            <el-table-column prop="position" label="位置" width="55" align="center"></el-table-column>
            <el-table-column label="操作" width="55" align="center">
                <template #default="scope">
                    <div class="edit" @click="showDetail(scope.row)">编辑</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <el-dialog v-model="dialogVisible" title="编辑" destroy-on-close width="400px">
        <el-form label-width="80px">
            <el-form-item label="基础">
                <colorPicker v-model="colorDetail.color1"></colorPicker>
            </el-form-item>
            <el-form-item label="渐变">
                <colorPicker v-model="colorDetail.color2"></colorPicker>
            </el-form-item>
            <el-form-item label="位置">
                <el-input-number v-model="colorDetail.position" :min="0" :max="100" size="small" />
            </el-form-item>
        </el-form>
    </el-dialog>
</template>
<script>
import { Edit } from '@element-plus/icons-vue'
import colorPicker from './color-picker.vue';
export default {
    data() {
        return {
            Edit: Edit,
            dialogVisible: false,
            colorDetail: {}
        }
    },
    components: { colorPicker },
    props: {
        modelValue: {
            type: Object
        }
    },
    methods: {
        showDetail(data) {
            this.dialogVisible = true;
            this.colorDetail = {}
            this.colorDetail = data;
        },
    }
}
</script>
<style>
.colorPan {
    width: 30px;
    height: 30px;
    border-radius: 2px;
}

.color-table {

    .el-table th,
    .el-table tr,
    .el-table td {
        background-color: #202023;
        color: white;
    }

    .el-table {
        background-color: #202023;
        --el-table-border-color: none
    }

    .edit {
        color: #409EFF;
        font-size: 12px;
        cursor: pointer;
    }
}
</style>